// extracted by mini-css-extract-plugin
export default {"menuBlock":"VF-z","title":"WF-z","nav":"XF-z","flexCell":"YF-z","facetLink":"ZF-z"};